import {useMemo} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
  selectActiveOrdersForDisplay,
  selectOrderTrackerLoading,
  selectOrderTrackerError,
} from '../../../../redux/orderTracker';
import {fetchActiveOrders} from '../../../../redux/orderTracker';
import {AppDispatch} from '../../../../redux/store';
import {OrderStatusDto} from '../model/types';

export const useActivityTrackerData = () => {
  const dispatch = useDispatch<AppDispatch>();

  const orders = useSelector(selectActiveOrdersForDisplay);
  const isLoading = useSelector(selectOrderTrackerLoading);
  const error = useSelector(selectOrderTrackerError);

  const processedOrders = useMemo<OrderStatusDto[]>(() => orders, [orders]);

  return {
    orders: processedOrders,
    isLoading,
    hasError: Boolean(error),
    hasTodayOrders: processedOrders.length > 0,
    refetch: () => dispatch(fetchActiveOrders()),
  };
};
